<div class="table-header-row" [ngClass]="{ downloadReportTable: isDownloadReportList }">
  <span class="table-title">
    {{ (title | uppercase) + ('shared.list' | xTranslate) }}
    <span class="record-compare-sub-header">
      <span class="result-num">{{ pageSize }}</span>
      <span class="results">
        {{ pageSize === 1 ? ('recordsSearch.result' | xTranslate) : ('recordsSearch.results' | xTranslate) }}</span
      >
    </span>
  </span>
  <span *ngIf="commands && !isDownloadReportList" class="toolbar flt-right">
    <miq-commands [resources]="selectedResources" [commands]="commands" (rowChange)="rowChange.emit()"></miq-commands>
  </span>
</div>

<p-table
  [columns]="columns"
  [value]="elements"
  [paginator]="true"
  [rows]="selectedRowsPerPage"
  [totalRecords]="elements.length"
  paginatorDropdownAppendTo="body"
  [rowsPerPageOptions]="[10, 15, 20]"
  [(selection)]="selectedResources"
  [customSort]="true"
  [resetPageOnSort]="false"
  (sortFunction)="sort($event)"
  [sortField]="defaultSorting"
  [sortOrder]="defaultSortOrder"
  [dataKey]="dataKey"
  selectionMode="multiple"
  (selectionChange)="onSelectionChange($event)"
>
  <ng-template templeate pTemplate="header" let-columns>
    <tr>
      <th
        scope="col"
        *ngFor="let col of columns"
        [pSortableColumn]="col.field"
        [pSortableColumnDisabled]="!col.sortable"
        [style.width]="col.width"
      >
        {{ col.header | xTranslate }}
        <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
        <miq-tableHeaderCheckbox *ngIf="col.checkbox"></miq-tableHeaderCheckbox>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <ng-container>
      <tr
        miq-tree-data-row
        [row]="rowData"
        [columns]="columns"
        (toggle)="toggle($event)"
        (rowChange)="rowChange.emit($event)"
      ></tr>
    </ng-container>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length + 1">
        {{ ('shared.no' | xTranslate | titlecase) + (title || 'elements' | lowercase) + ('shared.found' | xTranslate) }}
      </td>
    </tr>
  </ng-template>
</p-table>
